import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import Box from '@material-ui/core/Box'
import InputBase from '@material-ui/core/InputBase'
import { fade, withStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'

const styles = theme => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#cacaca', 0.3),
    '&:hover': {
      backgroundColor: fade('#cacaca', 0.3),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    padding: theme.spacing(0, 0.5),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    top: 0,
    cursor:'pointer'
  },  
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 0, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    paddingRight: `calc(1em + ${theme.spacing(2)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
  boldText: {
    fontWeight: 'bold'
  }
})

const SearchBar = ({ theme, classes, children, ...props }) => {

  const { onChange, search, onClear, onEnter } = props
  
  return (
    <Box display='flex' flexGrow={1}>
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
            placeholder="Search…"
            classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
            onChange={onChange}
            value={search}
            onKeyDown={onEnter}
        />

        { search !== '' &&
          <div className={classes.closeIcon}>
              <CloseIcon onClick={ onClear }/>
          </div>
        }
      </div>
    </Box>
  )
}

export default withStyles(styles, { withTheme: true })(
    (SearchBar)
)
